export type DependentHookRow = {
  uuid: string;
  label: string;
};

type DependentHooksNoticeProps = {
  intro: string;
  hooks: DependentHookRow[];
};

export const DependentHooksNotice = ({
  intro,
  hooks
}: DependentHooksNoticeProps) => (
  <div className="flex flex-col gap-1">
    <p>{intro}</p>
    <ul className="list-disc pl-5">
      {hooks.map(({ uuid, label }) => (
        <li key={uuid} className="break-all">
          {label}
        </li>
      ))}
    </ul>
  </div>
);
